import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SIZES = {
  sm: 'h-8 w-8',
  md: 'h-9 w-9',
};

const TONES = {
  default: 'border-[color:var(--app-border)] text-[color:var(--app-muted)] hover:border-emerald-500/60 hover:text-emerald-400',
  red: 'border-[color:var(--app-border)] text-[color:var(--app-muted)] hover:border-red-500/60 hover:text-red-400',
  amber: 'border-[color:var(--app-border)] text-[color:var(--app-muted)] hover:border-amber-500/60 hover:text-amber-400',
  muted: 'border-[color:var(--app-border)] text-[color:var(--app-muted)] hover:text-[color:var(--app-text)]',
};

function IconButton({
  icon,
  label,
  onClick,
  size = 'sm',
  tone = 'default',
  border = true,
  iconClass = 'text-[13px]',
  disabled = false,
  className = '',
}) {
  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
      className={`flex items-center justify-center rounded-md transition disabled:opacity-30 ${SIZES[size]} ${border ? 'border' : ''} ${className || TONES[tone]}`}
    >
      <FontAwesomeIcon icon={icon} className={iconClass} />
    </button>
  );
}

export default IconButton;
